/**
 * @description 去除表单的placeholder
 * @param {string} selector 选择器
 */
function clearPlaceholder(selector) {
  const dom = document.querySelector(selector)
  if (dom) {
    const inputs = dom.querySelectorAll('input')
    const textareas = dom.querySelectorAll('textarea')
    inputs.forEach((input) => {
      input.setAttribute('placeholder', '')
    })
    textareas.forEach((input) => {
      input.setAttribute('placeholder', '')
    })
  }
}

export default clearPlaceholder
